// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IkNF","question":"styles_question__2Xbp3","description":"styles_description__2lExb"};